import type { OptionDef } from '../../option_def';

export function createScopeOptionDef(description: string): OptionDef {
  return {
    flags: '--scope <scope>',
    description,
    default: 'user',
    choices: ['user', 'project', 'local'],
  };
}
